import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    // `updateViaCache: 'none'` tells the browser to never use the HTTP cache when checking
    // whether service-worker.js itself changed — without this, a long-lived cache on that
    // one file can make the browser think "nothing's new" even right after a fresh deploy.
    navigator.serviceWorker.register('/service-worker.js', { updateViaCache: 'none' }).then((reg) => {
      // Covers installed/resumed PWAs that rarely do a fresh navigation (so the browser's own
      // lazy ~24h update check almost never runs) — proactively ask for an update check every
      // time the app is (re)opened or brought to the foreground, and every hour while it's open.
      reg.update().catch(() => {});
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') reg.update().catch(() => {});
      });
      setInterval(() => reg.update().catch(() => {}), 60 * 60 * 1000);
    }).catch((e) => console.error('[SPC] service worker registration failed:', e));

    // Our service worker calls skipWaiting()+clients.claim() unconditionally, so a new version
    // takes control the moment it finishes installing — this is what makes that take effect
    // immediately for already-open tabs instead of needing a manual hard refresh.
    let reloaded = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (reloaded) return;
      reloaded = true;
      window.location.reload();
    });
  });
}
